import React from 'react';
import AffiliateList from '../components/affiliate/AffiliateList';
import { getBlackBelts, getAffiliatesByState } from '../view/HTTPService';

/**
 * /affiliatesState - Lista com dropdown de filtro por estado.
 * Carrega faixas pretas por padrão e permite filtrar por estado.
 */
export default function AffiliatesStatePage() {
    return (
        <AffiliateList
            titleKey="msg.jkaAllByState"
            fetchAffiliates={getBlackBelts}
            filterByState={getAffiliatesByState}
        />
    );
}
